import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["assetFileStatus"],
  _excluded2 = ["fileStatus"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useEffect, useState } from 'react';
import useFetchFileStatus from './useFetchFileStatus';
import { FILE_STATUS_VALUES } from './constants';
function useProcessingFileStatus(_ref) {
  var assetFileStatus = _ref.assetFileStatus,
    otherOptions = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFileProcessing = _useState2[0],
    setIsFileProcessing = _useState2[1];
  var _useFetchFileStatus = useFetchFileStatus(_objectSpread({
      enabled: isFileProcessing
    }, otherOptions)),
    _useFetchFileStatus$f = _useFetchFileStatus.fileStatus,
    fileStatus = _useFetchFileStatus$f === void 0 ? assetFileStatus : _useFetchFileStatus$f,
    rest = _objectWithoutProperties(_useFetchFileStatus, _excluded2);
  useEffect(function () {
    if (fileStatus === FILE_STATUS_VALUES.READY || fileStatus === FILE_STATUS_VALUES.INVALID || fileStatus === FILE_STATUS_VALUES.DRAFT) {
      setIsFileProcessing(false);
    } else {
      setIsFileProcessing(true);
    }
  }, [fileStatus]);
  var isProcessingStatusShowing = fileStatus === FILE_STATUS_VALUES.PROCESSING || fileStatus === FILE_STATUS_VALUES.DRAFT || fileStatus === FILE_STATUS_VALUES.INVALID;
  return _objectSpread({
    fileStatus: fileStatus,
    isProcessingStatusShowing: isProcessingStatusShowing
  }, rest);
}
export default useProcessingFileStatus;